import { AbstractDTO } from "./abstract";
import { GalleryLayout } from "@signature-it/ngx-generic/enums";

export class GalleryConfigDTO extends AbstractDTO  {
    layout: string;
	api: string;
    extraQryString: string;
    hideIndicator: boolean;
    showOriginalSize: boolean;
    hideTitle: boolean;
    hideDescription: boolean;
    subTitle: boolean;
    responsive: object;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        
        this.layout = attributes['layout'] || GalleryLayout.CAROUSEL;
        this.api = attributes['api'] || "";
        this.extraQryString = attributes['extraQryString'] || "";
        this.hideIndicator = attributes['hideIndicator'] || false;
        this.showOriginalSize = attributes['showOriginalSize'] || false;
        this.hideDescription = attributes['hideDescription'] || false;
        this.subTitle = attributes['subTitle'] || false;
        this.hideTitle = attributes['hideTitle'] || false;
        this.responsive = attributes['responsive'] || null;
    }

}
